import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';

import { Col, Form, Row } from 'react-bootstrap';

// import useForm from 'react-hook-form'
import AlertService from '../../../../../components/SweetAlert';
import ToastUtil from '../../../../../components/ToastNotification/ToastUtil';
import { config } from '../../../../../config/index';
import LayoutContext from '../../../../../store/Layout/contexts';
const { API_URL } = config;

const AddSupervisor = (props) => {
  // const { handleSubmit, register, errors } = useForm()

  const token = localStorage.getItem('token');
  const [clients, setClients] = useState([]);
  const [activeClient, setActiveClient] = useState([]);
  const [sites, setSites] = useState([]);
  const [activeSites, setActiveSites] = useState([]);
  const [shifts, setShifts] = useState([]);

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [employeeNo, setEmployeeNo] = useState('');
  const [employeeID, setEmployeeID] = useState('');
  const [gender, setGender] = useState(0);
  const [race, setRace] = useState(0);
  const [dateOfBirth, setDateOfBirth] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNo, setPhoneNo] = useState('');

  const [validated, setValidated] = useState(false);

  const [siteSupervisors, setSiteSupervisors] = useState([]);

  const firstNameHandler = (e) => setFirstName(e.target.value);
  const lastNameHandler = (e) => setLastName(e.target.value);
  const employeeNoHandler = (e) => setEmployeeNo(e.target.value);
  const employeeIDHandler = (e) => setEmployeeID(e.target.value);
  const genderHandler = (e) => setGender(e.target.value);
  const raceHandler = (e) => setRace(e.target.value);
  const dateOfBirthHandler = (e) => setDateOfBirth(e.target.value);
  const emailHandler = (e) => setEmail(e.target.value);
  const phoneNoHandler = (e) => setPhoneNo(e.target.value);

  const clientHandler = (e) => {
    setActiveClient(
      [...clients].find((client) => client.id === parseInt(e.target.value))
    );
    setActiveSites(
      [...sites].filter((site) => site.client_id === parseInt(e.target.value))
    );
    setSiteSupervisors([]);
  };

  const siteHandler = (e) => {
    const pickedSite = JSON.parse(e.target.value);
    if (
      !siteSupervisors.some(
        (siteSupervisor) => siteSupervisor.site_id === parseInt(pickedSite.id)
      )
    ) {
      addSiteSupervisors(pickedSite.id, pickedSite.name);
    }
  };

  const startDateHandler = (index, e) => {
    let siteSupervisorsArr = [...siteSupervisors];
    siteSupervisorsArr[index].start_date = e.target.value;
    setSiteSupervisors(siteSupervisorsArr);
  };

  const resignDateHandler = (index, e) => {
    let siteSupervisorsArr = [...siteSupervisors];
    siteSupervisorsArr[index].resign_date = e.target.value;
    setSiteSupervisors(siteSupervisorsArr);
  };

  const lastDayDateHandler = (index, e) => {
    let siteSupervisorsArr = [...siteSupervisors];
    siteSupervisorsArr[index].last_day_date = e.target.value;
    setSiteSupervisors(siteSupervisorsArr);
  };

  const addSiteSupervisors = (id, name) =>
    setSiteSupervisors([
      ...siteSupervisors,
      {
        name,
        site_id: id,
        start_date: null,
        resign_date: null,
        last_day_date: null,
      },
    ]);

  const removeSiteSupervisor = (index) =>
    setSiteSupervisors(
      [...siteSupervisors].filter((siteSupervisor, i) => i !== index)
    );

  const discardHandler = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to discard all input fields?'
      )
    ) {
      setFirstName('');
      setLastName('');
      setEmployeeNo('');
      setEmployeeID('');
      setGender(0);
      setRace(0);
      setDateOfBirth('');
      setEmail('');
      setPhoneNo('');
      setActiveClient(null);
      setActiveSites([]);
    }
  };

  const fetchClients = async () => {
    try {
      let url = `${API_URL}/client`;

      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      if (response.ok) {
        let data = await response.json();

        setClients(data.data);
      } else {
        console.log(response.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchSites = async () => {
    const url = `${API_URL}/sites`;
    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let json = await response.json();

      if (response.ok) {
        setSites(json.data);
        // setActiveSite(json.data[0])
      } else {
        ToastUtil.error('Sites is not available');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchShifts = async () => {
    const url = `${API_URL}/shifts`;
    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let json = await response.json();

      if (response.ok) {
        setShifts(json.data);
        // setActiveSite(json.data[0])
      } else {
        ToastUtil.error('Shifts is not available');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const submitSiteSupervisor = async (id) => {
    const url = `${API_URL}/supervisor/${id}/assignsite`;

    if (siteSupervisors.length > 0) {
      try {
        const siteSupervisorsArr = [...siteSupervisors];

        siteSupervisorsArr.map((site) => (site.Supervisor_id = id));

        return await fetch(url, {
          method: 'POST',
          body: JSON.stringify({ sites: siteSupervisorsArr }),
          withCredentials: true,
          mode: 'cors',
          headers: {
            Authorization: token,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json; charset=utf-8',
          },
        });
      } catch (error) {
        console.log(error);
      }
    }
  };

  const submitSupervisor = async () => {
    const data = {
      first_name: firstName,
      last_name: lastName,
      employee_id: employeeID,
      employee_no: employeeNo,
      gender_id: gender,
      race_id: race,
      date_of_birth: dateOfBirth,
      email,
      phone_no: phoneNo,
    };

    const url = `${API_URL}/supervisor/register`;

    try {
      return await fetch(url, {
        method: 'POST',
        body: JSON.stringify(data),
        withCredentials: true,
        mode: 'cors',
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to add this Supervisor?'
      )
    ) {
      try {
        let supervisor_response = await submitSupervisor();
        let supervisor_json = await supervisor_response.json();

        if (supervisor_json.success) {
          let supervisor_id = supervisor_json.data.supervisor_id;

          let site_supervisor_response = await submitSiteSupervisor(
            supervisor_id
          );
          let site_supervisor_json = await site_supervisor_response.json();

          if (site_supervisor_json.success) {
            ToastUtil.success('Successfully added Supervisor!');
            window.location.replace(`${window.location.origin}/supervisors`);
          } else {
            ToastUtil.error(site_supervisor_json.message);
          }
        } else {
          ToastUtil.error(supervisor_json.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      await submitHandler(event);
    }

    setValidated(true);
  };

  useEffect(() => {
    fetchClients();
    fetchSites();
    fetchShifts();
  }, []);

  return (
    <LayoutContext.Consumer>
      {({ activeSidebar }) => (
        <div style={{ paddingTop: '3rem' }}>
          <div
            className="d-flex flex-column"
            style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
          >
            <NavLink
              to={`/supervisors`}
              className="text-decoration-none"
              style={{ color: 'inherit' }}
            >
              <div>
                <i className="fas fa-chevron-left pe-2"></i> Supervisor
                Management
              </div>
            </NavLink>
            <div className="pt-4">
              <h3>Add Supervisor</h3>
            </div>
          </div>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div
              className="border rounded d-flex"
              style={{
                marginTop: '2rem',
                marginLeft: '3rem',
                marginRight: '3rem',
              }}
            >
              <div
                style={{
                  minWidth: '15rem',
                  width: '15rem',
                  backgroundColor: '#f3f3f3',
                  padding: '2.25rem',
                }}
                className="border-right"
              >
                <strong>Supervisor Information</strong>
                <p className="pt-2 text-muted">
                  View and edit supervisor information
                </p>
              </div>
              <div
                className="flex-grow-1 bg-white"
                style={{ padding: '2.25rem' }}
              >
                <Row className="mb-3">
                  <Form.Group as={Col} md="6">
                    <Form.Label>
                      <strong>First Name*</strong>
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      value={firstName}
                      placeholder="First name"
                      onChange={(e) => firstNameHandler(e)}
                      maxLength={60}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter first name.
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Label>
                      <strong>Last Name*</strong>
                    </Form.Label>
                    <Form.Control
                      required
                      value={lastName}
                      type="text"
                      placeholder="Last name"
                      onChange={(e) => lastNameHandler(e)}
                      maxLength={60}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter last name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} md="12">
                    <Form.Label>
                      <strong>Employee No*</strong>
                    </Form.Label>
                    <Form.Control
                      required
                      value={employeeNo}
                      type="text"
                      placeholder="Employee No"
                      onChange={(e) => employeeNoHandler(e)}
                      maxLength={12}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter employee no.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} md="12">
                    <Form.Label>
                      <strong>Employee ID</strong>
                    </Form.Label>
                    <Form.Control
                      value={employeeID}
                      type="text"
                      placeholder="Employee ID"
                      onChange={(e) => employeeIDHandler(e)}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter employee id.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} md="4">
                    <strong>Gender</strong>
                    <Form.Control
                      as="select"
                      type="select"
                      onChange={(e) => genderHandler(e)}
                      value={gender}
                    >
                      <option value="">Select Gender</option>
                      <option value="1">Male</option>
                      <option value="2">Female</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      Please select a race.
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="4">
                    <strong>Race</strong>
                    <Form.Control
                      as="select"
                      type="select"
                      onChange={(e) => raceHandler(e)}
                      value={race}
                    >
                      <option value="">Select Race</option>
                      <option value="1">Chinese</option>
                      <option value="2">Malay</option>
                      <option value="3">Indian</option>
                      <option value="4">Others</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      Please select a race.
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="4">
                    <strong>Date Of Birth</strong>
                    <Form.Control
                      type="date"
                      name="dateOfBirth"
                      placeholder="Date Of Birth"
                      value={dateOfBirth}
                      onChange={(e) => dateOfBirthHandler(e)}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter date of birth.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} md="12">
                    <Form.Label>
                      <strong>Email*</strong>
                    </Form.Label>
                    <Form.Control
                      required
                      value={email}
                      type="email"
                      placeholder="Email"
                      onChange={(e) => emailHandler(e)}
                      maxLength={100}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter valid email.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} md="12">
                    <Form.Label>
                      <strong>Phone No</strong>
                    </Form.Label>
                    <Form.Control
                      value={phoneNo}
                      type="text"
                      placeholder="Phone Number"
                      onChange={(e) => phoneNoHandler(e)}
                      maxLength={20}
                    />
                  </Form.Group>
                </Row>
              </div>
            </div>
            <div
              className="border rounded d-flex"
              style={{
                marginTop: '2rem',
                marginLeft: '3rem',
                marginRight: '3rem',
                marginBottom: '6rem',
              }}
            >
              <div
                style={{
                  minWidth: '15rem',
                  width: '15rem',
                  backgroundColor: '#f3f3f3',
                  padding: '2.25rem',
                }}
                className="border-right"
              >
                <strong>Assigned To</strong>
                <p className="pt-2 text-muted">
                  Manage client and site assignation
                </p>
              </div>
              <div
                className="flex-grow-1 bg-white"
                style={{ padding: '2.25rem' }}
              >
                <Row>
                  <Form.Group as={Col} md="12">
                    <strong>Client*</strong>
                    <Form.Control
                      as="select"
                      required
                      type="select"
                      onChange={(e) => clientHandler(e)}
                    >
                      <option value="">Select Client*</option>
                      {clients &&
                        clients.map((client) => (
                          <option key={client.id} value={client.id}>
                            {client.name}
                          </option>
                        ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      Please select a client.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} md="12">
                    <strong>Sites*</strong>
                    <Form.Control
                      as="select"
                      required
                      type="select"
                      onChange={(e) => siteHandler(e)}
                    >
                      <option value="">Select Site</option>
                      {activeSites &&
                        activeSites
                          .filter((site) => site.active === true)
                          .map((site) => (
                            <option key={site.id} value={JSON.stringify(site)}>
                              {site.name}
                            </option>
                          ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      Please select a site.
                    </Form.Control.Feedback>
                  </Form.Group>
                  <div className="col-sm-12">
                    {siteSupervisors.map((siteSupervisor, index) => (
                      <div className="pt-3">
                        <div className="d-flex justify-content-between">
                          <strong>{siteSupervisor.name}</strong>
                          <p
                            style={{ cursor: 'pointer' }}
                            className="text-danger"
                            onClick={() => removeSiteSupervisor(index)}
                          >
                            Remove
                          </p>
                        </div>
                        <div
                          className="border rounded mt-2"
                          style={{ padding: '2.25rem' }}
                        >
                          <Row>
                            <Form.Group as={Col} md="6">
                              <strong>Start Date*</strong>
                              <Form.Control
                                type="date"
                                value={siteSupervisor.start_date}
                                onChange={(e) => startDateHandler(index, e)}
                                required
                              />
                              <Form.Control.Feedback type="invalid">
                                Please enter start date.
                              </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group as={Col} md="6">
                              <strong>Resign Date</strong>
                              <Form.Control
                                type="date"
                                value={siteSupervisor.resign_date}
                                onChange={(e) => resignDateHandler(index, e)}
                              />
                            </Form.Group>
                            <Form.Group as={Col} md="6">
                              <strong>Last Day Date</strong>
                              <Form.Control
                                type="date"
                                value={siteSupervisor.last_day_date}
                                onChange={(e) => lastDayDateHandler(index, e)}
                              />
                            </Form.Group>
                          </Row>
                        </div>
                      </div>
                    ))}
                  </div>
                </Row>
              </div>
            </div>
            <div
              style={{
                position: 'fixed',
                bottom: 0,
                width: activeSidebar ? 'calc(100vw - 310px)' : '100vw',
                height: '4.5rem',
                paddingRight: '3rem',
              }}
              className="border-top bg-white d-flex align-items-center justify-content-end"
            >
              <button
                type="button"
                onClick={discardHandler}
                className="btn btn-outline-brand"
                style={{ width: '12rem' }}
              >
                Discard
              </button>
              <button
                type="submit"
                className="btn btn-brand ms-3"
                style={{ width: '12rem' }}
              >
                Save changes
              </button>
            </div>
          </Form>
        </div>
      )}
    </LayoutContext.Consumer>
  );
};

export default AddSupervisor;
